import { Expose, Type } from 'class-transformer';
import { AddLocationType, LocationType, ShippingType } from '../../shared-features/enums/shared-enums.enum';
import { City } from '../../shared-features/models/city.model';
import { DropdownModel } from '@shared/models/dropdown-model.model';
import { UserLocation } from '../../users/models/user-location.model';
import { WCCRegion } from '../../shipment-creation-template/models/wcc-region.model';
import { WCCReceiver } from '../../shipment-creation-template/models/wcc-receiver.model';
import { GateDefinition } from '../../shipments/models/gate-definition.model';
import { LocationStatus } from '../../shared-features/enums/location-status.enum';

export class LocationModel extends DropdownModel {
  @Expose() id?: number;
  @Expose() title? = '';
  @Expose() cityId?: number;
  @Expose() value?: string;
  @Type(() => City)
  @Expose()
  city?: City = new City();
  @Expose() address? = '';
  @Expose() latitude?: number = null;
  @Expose() longitude?: number = null;
  @Expose() isDefault? = false;
  @Expose() selected? = false;
  @Expose() type?: LocationType = LocationType.Customer;
  @Expose()
  totalShipmentsCount?: number;

  @Expose()
  shippingType?: ShippingType;
  @Expose() status?: LocationStatus;

  @Expose()
  @Type(() => UserLocation)
  usersLocations?: UserLocation[];

  @Expose()
  createdByCustomer?: number;

  @Expose()
  @Type(() => WCCReceiver)
  wccReceiver?: WCCReceiver;

  @Expose()
  @Type(() => WCCRegion)
  wccRegion?: WCCRegion;

  locationType?: AddLocationType;

  @Expose()
  @Type(() => GateDefinition)
  gates?:GateDefinition[];

  get dropDownDisplayName(): string {
    return [this.title, this.city?.name].filter(Boolean).join(' - ');
  }

  get dropDownValue(): object {
    return this;
  }

  @Expose()
  get latlng(): google.maps.LatLngLiteral {
    return {
      lat: this.latitude,
      lng: this.longitude,
    };
  }
}
